import { useEffect } from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useTheme } from "@mui/material/styles"
import { CircularProgress, Typography } from "@mui/material"

import useDeleteEntity from "../../hooks/useDeleteEntity"

interface DeleteDialog {
    id: string
    open: boolean
    setOpen: (item: boolean) => void
    refetch: () => void
}
export default function DeleteRole({
    id,
    open,
    setOpen,
    refetch,
}: DeleteDialog) {

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

    const { isPending, mutate, data } = useDeleteEntity(`roles/${id}`)

    const handleDelete = () => {
        mutate()
    }

    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        if (data) {
            setOpen(false)
            refetch()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    return (
        <div>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="delete-role-dialog-title"
            >
                <DialogTitle
                    id="delete-role-dialog-title"
                    sx={{ bgcolor: "#fafafa" }}
                >
                    <Typography
                        variant="h5"
                        sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                        Delete Role
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ m: 2 }}>
                    <DialogContentText>
                        <Typography variant="body1">
                            Are you sure, do you want to delete the selected
                            role?
                            <br />
                            This is an irriversible action!
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ bgcolor: "#fafafa" }}>
                    <Button variant="contained" autoFocus onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleDelete}
                        autoFocus
                        color="error"
                    >
                        Delete
                        {isPending && (
                            <CircularProgress
                                size={24}
                                sx={{
                                    color: "black",
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    marginTop: "-12px",
                                    marginLeft: "-12px",
                                }}
                            />
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
